(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('lugares', {
                parent: 'public',
                redirectTo: 'lugares/list',
                data: {
                    authorities: []
                }
            })
            .state('lugares/list', {
                parent: 'lugares',
                url: '/lugares',
                params: {page: {value: '1', dynamic: true}},
                data: {
                    pageTitle: 'lugares.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/public/lugar/lugares.html',
                        controller: 'LugarController',
                        controllerAs: 'ctrl'
                    }
                }
            });
    }
})();
